export const CreateQueryString = (query) => {  
  return `?${Object.keys(query).map(key => {
    if (typeof query[key] == 'object') {
      return Object.keys(query[key]).map(k => `${encodeURIComponent(key + '[' + k + ']')}=${encodeURIComponent(query[key][k])}`).join('&');
    } else {
      return key + '=' + encodeURIComponent(query[key]);
    }
  }).join('&')}`;
}

export const OpenLinkInPopup = ({url, title, w, h}) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft
  const top = (height - h) / 2 / systemZoom + dualScreenTop
  const newWindow = window.open(url, title, 
    `
    scrollbars=yes,
    width=${w}, 
    height=${h}, 
    top=${top}, 
    left=${left}
    `
  )
  
  if (!newWindow) window.open(url, '_blank')
  if (window.focus) newWindow.focus();
}